import * as _ from 'lodash';
import * as $ from 'jquery';
import * as d3 from 'd3';

import { FormatHelper } from './helpers/format';
import { DateHelper } from './helpers/date';

const YAXIS_GRID_STROKE = '#e5e5e5';

export function getEventDatum(datum) {
  return {
    x: datum.x.value,
    y: datum.y.value,
    key: datum.key,
  };
}

export function LayeredArea(options){
  var settings = $.extend({ // Merge options to default settings.
    $el: d3.select("body"),
    title: "",
    data: [],
    margin: {top: 20, right: 80, bottom: 30, left: 50},
    padding: {top: 0, right: 0, bottom: 0, left: 0},
    width: 960,
    height: 500,
    color: d3.scaleOrdinal(d3.schemeCategory10), // d3.scale.category20(),
    yearRange: [1990, 2023],
    format: d3.format(',.0f'),
    isLock: false,
    lockedTarget: null,
    tip: null,
    isCountryProfile: false,
    onClick: null,
    onHover: null,
  }, options);

  var self = this;
  self.chart = null;
  Object.keys(settings).forEach(function(k) {
    self[k] = settings[k];
  });

  this.render();
}

LayeredArea.prototype.render = function() {
  var self = this;
  var sortedData = _.orderBy(_.cloneDeep(this.data), e => e.values[0][1], 'desc');
  var margin = this.margin;
  var color = this.color;
  // var reserved_value = 0.1;
  var keyColor = function(d, i) {
    return color(d.key)
  };
  var min_year = self.yearRange[0];
  var max_year = self.yearRange[1];
  const values = sortedData.map(d => d.values.map(d2 => d2[1])).flat();
  self.min_value = Math.min(...values);
  self.max_value = Math.max(...values);
  if (self.min_value > 0 && self.max_value > 0) {
    self.min_value = 0;
  } else if (self.min_value < 0 && self.max_value < 0) {
    self.max_value = 0;
  }
  if (self.min_value === self.max_value) {
    self.max_value++;
  }

  // this.format = function(d){
  //   if(d == reserved_value || d === "") {
  //     return "No data";
  //   }
  //   else if(self.min_value >= -self.threshold && self.max_value <= self.threshold) {
  //     return d3.format(',.' + self.decimal_point + 'f')(d);
  //   }
  //   else {
  //     return d3.format(',.0f')(d);
  //   }
  // }

  var width = self.width - margin.left - margin.right - self.padding.left - self.padding.right,
      height = self.height - margin.top - margin.bottom - self.padding.top - self.padding.bottom;

  this.x = d3.scaleTime()
    .domain([DateHelper.getDateObjFromYear(min_year), DateHelper.getDateObjFromYear(max_year)])
    .range([0, width]);

  this.y = d3.scaleLinear()
    .range([height, 0])
    .domain([self.min_value, self.max_value]);

  this.xAxis = d3.axisBottom()
    .scale(this.x)
    .ticks(d3.timeYear)
    .tickPadding(7)
    .tickSizeInner(0)
    .tickSizeOuter(0);

  this.yAxis = d3.axisLeft()
    .scale(this.y)
    .tickFormat(function(d) {
      return FormatHelper.formatEscapNumber(self.max_value, self.min_value, d);
    })
    .tickSizeInner(-width)
    .tickSizeOuter(0);
  if (this.isCountryProfile) {
    this.yAxis.ticks(5);
  }

  var area = d3.area()
    .x(function(d) {
      return self.x(d[0]);
    })
    .y0(function(d) {
      return self.y(0);
    })
    .y1(function(d) {
      return self.y(d[1]);
    });

  this.$el.select('svg').remove();
  this.svg = this.$el.append("svg")
    .attr("width", this.width)
    .attr("height", this.height)
    .attr("class", "area-chart");

  // Wrapper for the margins
  this.gWrapper = this.svg.append("g")
    .attr('class', 'wrapper')
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  // Wrapper inner for padding of x and y axises
  this.gWrapperInner = this.gWrapper.append('g')
    .attr('class', 'wrapper-inner')
    .attr('transform', 'translate(' + self.padding.left + ', ' + self.padding.bottom + ')');

  this.gWrapperInner.append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + height + ")")
    .call(this.xAxis);

  this.gWrapperInner.append("g")
    .attr("class", "y axis")
    .call(this.yAxis)
    .selectAll('line')
      .style('stroke', YAXIS_GRID_STROKE);

  var areaG = this.gWrapperInner.append("g")
    .attr("class", "layered-area-g");

  areaG.selectAll(".area")
    .data(sortedData)
    .enter().append("path")
      .attr("class", "area")
      .attr("d", function(d) {
        return area(d.values);
      })
      .style("fill", keyColor)
      .attr("data-name", function(d){
        return d.key;
      });

  const points = sortedData.map(e => {
    return e.values.map(e2 => {
      const xVal = e2[0];
      const yVal = e2[1];
      return {
        x: { value: xVal, scale: this.x(xVal) },
        y: { value: yVal, scale: this.y(yVal) },
        key: e.key,
      };
    });
  }).flat();

  const delaunay = d3.Delaunay.from(points, d => d.x.scale, d => d.y.scale);
  // @see: https://observablehq.com/@didoesdigital/9-may-2020-d3-scatterplot-with-voronoi-tooltips
  const voronoi = delaunay.voronoi([
    0.5, 0.5, width - 0.5, height - 0.5
  ]);

  var circleG = this.gWrapperInner.append("g")
    .attr("class", "circle-g");

  self.vPointPaths = circleG
    .selectAll('path')
    .data(points)
    .join('path')
      .attr('d', (d, i) => {
        return voronoi.renderCell(i);
      })
      .style('fill', 'transparent');
      // .style('stroke', '#000'); // For debugging

  var dotGWrapper = this.gWrapperInner.append("g")
      .attr("class", "dot-g");

  self.dotG = dotGWrapper.selectAll('.dot')
    .data(points)
    .enter()
    .append('circle')
      .attr('class', 'dot')
      .attr('cx', function(d){ return d.x.scale })
      .attr('cy', function(d){ return d.y.scale })
      .attr('r', 5 )
      .attr('data-name', function(d) { return d.key; })
      .attr('data-year', function(d) { return d.x.value.getFullYear(); })
      .attr('data-value', function(d) { return d.y.value; })
      .style('fill', function(d) { return color(d.key); })
      .style('opacity', 0);

  this.svg.append("text")
      .attr('class', 'y-axis-label')
      .attr("transform", "rotate(-90)")
      .attr("x", (self.height/2) * -1)
      .attr('y', 0)
      .attr("dy", ".71em")
      .text(this.title)
      .call(self.wrapHeight, self.height);

  if (self.tip) {
    function getTooltipContent(el) {
      const $this = d3.select(el);
      const datum = $this.datum();
      return `<strong>${datum.key}:</strong> ${datum.x.value.getFullYear()}<br>`
        + `<center>${FormatHelper.formatEscapNumber(self.max_value, self.min_value, datum.y.value)}</center>`;
    }

    if (self.tip.context) {
      self.tip
        .context(this.gWrapper)
        .callbackTemplate(function(d) {
          return getTooltipContent(d.srcElement);
        })
        .init();
    }

    self.vPointPaths
      .on('mouseover', function(e) {
        if (self.isLock) return;
        const datum = d3.select(this).datum();
        const hoveredYear = datum.x.value.getFullYear(); // self.x.invert(e.layerX).getFullYear();
        self.$el.selectAll(`.dot[data-year="${hoveredYear}"]`)
          .style('opacity', 1); // .dispatch('mouseover');
      })
      .on('click', function(d) {
        if (self.isLock) {
          self.isLock = false;
          if (self.lockedTarget !== null) self.lockedTarget.style('opacity', 0);
          self.tip.hide(d);
          return;
        }
        self.isLock = true;
      })
      .on("mouseout", function(d,i) {
        if (self.isLock) return;
        self.$el.selectAll(`.dot`).style('opacity', 0);
      });

    self.dotG
      .on("mouseover", function(d) {
        if (self.isLock) return;

        const $this = d3.select(this);
        $this.style('opacity', 1);

        if (self.onHover) self.onHover(getEventDatum($this.datum()));
        if (self.tip.context) {
          self.tip.show(d, this);
          return;
        }
        const contentHtml = getTooltipContent(d.currentTarget);
        self.tip.show(d, contentHtml);
      })
      .on("click", function(d) {
        if (!self.isLock) {
          const thisSelection = d3.select(this);
          self.isLock = true;
          self.lockedTarget = thisSelection;
          if (self.onClick) self.onClick(getEventDatum(thisSelection.datum()));
          return;
        }
        self.isLock = false;
        if (self.lockedTarget !== null) self.lockedTarget.style('opacity', 0);
        self.tip.hide(d);
      })
      .on("mouseout", function(d) {
        if (self.isLock) return;

        const $this = d3.select(this);
        $this.style('opacity', 0);

        self.tip.hide(d);
      });
  }
}

LayeredArea.prototype.redraw = function(data, max) {
  var self = this;
  if(self.chart){
    var colors = this.color;
    var keyColor = function(d, i) {return colors(d.key)};
    self.chart.color(keyColor);
    self.$el.select("svg").datum(data).transition().duration(0).call(self.chart);
    self.$el.select("svg").select('.nv-x.nv-axis').selectAll('.tick').select('line').style('opacity',0)
    nv.utils.windowResize(self.chart.update);
  }else{ // Fall back sometime it try to redraw without initiate chart (since nv.addGraph takes some time to be executed)
    this.data = data;
    this.render();
  }
}

LayeredArea.prototype.wrapHeight = function(text, width){
  text.each(function() {
    var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
      // console.log(x);
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
}
